<template>
  <div>
    <hr class="kiosk-horizontal-line mb-2" />
    <h2 class="kiosk-pass-title mb-3 text-center">
      {{ $t("kiosk.user_authentication") }}
    </h2>
    <InfoBox
      v-if="state.reqResponse.message"
      class="border-0 v3-info-box danger w-100 mb-3"
      ><div
        class="v3-info-box-title v3-info-box-title-not-bold m-0 not-bold"
        role="alert"
        aria-live="assertive"
      >
        {{ state.reqResponse.message }}
      </div></InfoBox
    >
    <CRow class="m-auto gap-3 mb-3">
      <button
        type="button"
        data-test-id="kiosk-login-methods-student-number"
        class="col v3kiosk-login-methods"
        :class="{
          'v3kiosk-login-methods-active':
            state.authTypes.studentNumber.isVisible
        }"
        :aria-pressed="
          state.authTypes.studentNumber.isVisible ? 'true' : 'false'
        "
        @click="setLoginType('studentNumber')"
      >
        <div class="v3kiosk-login-methods-box">
          <i class="ri-user-line" aria-hidden="true"></i>
        </div>
        <div class="v3kiosk-login-methods-text">
          {{ $t("kiosk.student_number") }}
        </div>
        <div
          v-if="state.authTypes.studentNumber.isVisible"
          class="v3kiosk-login-methods-selected-text"
        >
          {{ $t("common.selected") }}
        </div>
      </button>
      <button
        type="button"
        class="col v3kiosk-login-methods"
        :class="{
          'v3kiosk-login-methods-active': state.authTypes.barcode.isVisible
        }"
        :aria-pressed="state.authTypes.barcode.isVisible ? 'true' : 'false'"
        @click="setLoginType('barcode')"
      >
        <div class="v3kiosk-login-methods-box">
          <i class="ri-qr-scan-2-line" aria-hidden="true"></i>
        </div>
        <div class="v3kiosk-login-methods-text">
          {{ $t("kiosk.code_scan") }}
        </div>
        <div
          v-if="state.authTypes.barcode.isVisible"
          class="v3kiosk-login-methods-selected-text"
        >
          {{ $t("common.selected") }}
        </div>
      </button>
      <button
        type="button"
        class="col v3kiosk-login-methods"
        :class="{
          'v3kiosk-login-methods-active': state.authTypes.qrcode.isVisible
        }"
        :aria-pressed="state.authTypes.qrcode.isVisible ? 'true' : 'false'"
        @click="setLoginType('qrcode')"
      >
        <div class="v3kiosk-login-methods-box">
          <i class="ri-bank-card-2-line" aria-hidden="true"></i>
        </div>
        <div class="v3kiosk-login-methods-text">
          {{ $t("kiosk.card_scan") }}
        </div>
        <div
          v-if="state.authTypes.qrcode.isVisible"
          class="v3kiosk-login-methods-selected-text"
        >
          {{ $t("common.selected") }}
        </div>
      </button>
      <button
        type="button"
        data-test-id="kiosk-login-methods-email"
        class="col v3kiosk-login-methods"
        :class="{
          'v3kiosk-login-methods-active': state.authTypes.standart.isVisible
        }"
        :aria-pressed="state.authTypes.standart.isVisible ? 'true' : 'false'"
        @click="setLoginType('standart')"
      >
        <div class="v3kiosk-login-methods-box">
          <i class="ri-mail-line" aria-hidden="true"></i>
        </div>
        <div class="v3kiosk-login-methods-text">{{ $t("kiosk.email") }}</div>
        <div
          v-if="state.authTypes.standart.isVisible"
          class="v3kiosk-login-methods-selected-text"
        >
          {{ $t("common.selected") }}
        </div>
      </button>
    </CRow>

    <!-- Login student number -->
    <div v-if="state.authTypes.studentNumber.isVisible">
      <div class="kiosk-login-auth-box mb-3">
        <div class="image-title mb-1">
          {{ $t("kiosk.enter_student_number_below") }}
        </div>
      </div>
      <div class="mb-3">
        <Label html-for="kiosk-login-student-number-input">{{
          $t("kiosk.type_in_student_number")
        }}</Label>
        <InputField
          id="kiosk-login-student-number-input"
          data-test-id="kiosk-login-student-number"
          class="w-100"
          v-model="state.form.studentNumber"
          :invalid-feedback="
            errors.studentNumber ? $t(errors.studentNumber) : ''
          "
          :v-no-auto-fill-input="true"
          :autocomplete="false"
          :is-focused="true"
        />
      </div>
      <div
        class="d-flex justify-content-center gap-3 w-100 kiosk-user-login-actions"
      >
        <!-- <div class="kiosk-user-login-actions__col">
          <BaseButton
            class="w-100 d-flex align-items-center justify-content-center"
            rounded
            @click="goToMainScreen"
          >
            {{ $t("kiosk.cancel") }}
          </BaseButton>
        </div> -->
        <div class="kiosk-user-login-actions__col">
          <LoadingButton
            data-test-id="kiosk-login-student-number-submit-button"
            class="w-100 d-flex align-items-center justify-content-center"
            :is-loading="state.isLoading"
            @click="login('studentNumber')"
            rounded
            solid
          >
            {{ $t("kiosk.submit") }}
          </LoadingButton>
        </div>
      </div>
    </div>

    <!-- Login email -->
    <div v-if="state.authTypes.standart.isVisible">
      <div class="mb-3 kiosk-user-login-email-row">
        <CRow class="g-3 align-items-end text-start">
          <CCol cols="12" md="7" lg="6">
            <Label html-for="kiosk-user-login-email-input">
              {{ $t("kiosk.email") }}
            </Label>
            <InputField
              id="kiosk-user-login-email-input"
              data-test-id="kiosk-login-email"
              class="w-100"
              :invalid-feedback="errors.email ? $t(errors.email) : ''"
              v-model="state.form.email"
              :v-no-auto-fill-input="false"
              autocomplete="email"
            />
          </CCol>
          <CCol cols="12" md="5" lg="6">
            <Label
              html-for="kiosk-user-login-email-domain-select"
              label-id="kiosk-user-login-email-domain-label"
            >
              {{ $t("kiosk.email_domain") }}
            </Label>
            <CustomSelect
              v-if="schoolDomains"
              input-id="kiosk-user-login-email-domain-select"
              labelled-by="kiosk-user-login-email-domain-label"
              hide-floating-label
              :close-on-select="true"
              :searchable="false"
              v-model="state.activeDomain"
              :options="schoolDomains"
              :accessible-label="$t('kiosk.email_domain')"
            />
          </CCol>
        </CRow>
      </div>
      <div class="mb-3">
        <Label html-for="kiosk-user-login-passcode-input">
          {{ $t("kiosk.kiosk_passcode") }}
        </Label>
        <InputField
          id="kiosk-user-login-passcode-input"
          data-test-id="kiosk-login-passcode"
          class="w-full"
          v-model="state.form.code"
          :invalid-feedback="errors.code ? $t(errors.code) : ''"
          :v-no-auto-fill-input="true"
          :autocomplete="false"
          input-type="password"
        />
      </div>
      <div
        class="d-flex justify-content-center gap-3 w-100 kiosk-user-login-actions"
      >
        <!-- <div class="kiosk-user-login-actions__col">
          <BaseButton
            class="w-100 d-flex align-items-center justify-content-center"
            rounded
            @click="goToMainScreen"
          >
            {{ $t("kiosk.cancel") }}
          </BaseButton>
        </div> -->
        <div class="kiosk-user-login-actions__col">
          <LoadingButton
            data-test-id="kiosk-login-submit-button"
            class="w-100 d-flex align-items-center justify-content-center"
            :is-loading="state.isLoading"
            @click="login('standart')"
            rounded
            solid
          >
            {{ $t("kiosk.submit") }}
          </LoadingButton>
        </div>
      </div>
    </div>
    <!-- Login card -->
    <div v-if="state.authTypes.qrcode.isVisible">
      <div class="kiosk-login-auth-box mb-3">
        <div class="image-title mb-3">{{ $t("kiosk.swipe_your_card") }}</div>
        <img
          class="image"
          src="@/assets/images/Kiosk-Swipe-Card.png"
          alt="swiper"
        />
      </div>
      <div class="mb-3">
        <Label> {{ $t("kiosk.swipe_your_card") }} </Label>
        <InputField
          class="w-100"
          v-model="state.form.qrCode"
          :v-no-auto-fill-input="true"
          :autocomplete="false"
          input-type="password"
          :is-focused="true"
        />
      </div>
      <!-- <div>
        <BaseButton
          class="w-100 d-flex align-items-center justify-content-center"
          rounded
          @click="goToMainScreen"
        >
          {{ $t("kiosk.cancel") }}
        </BaseButton>
      </div> -->
    </div>

    <!-- Login scan -->
    <div v-if="state.authTypes.barcode.isVisible">
      <div
        class="kiosk-login-auth-box mb-3 cursor-pointer"
        @click="launchScanner"
      >
        <div class="image-title mb-3">
          {{ $t("kiosk.click_to_scan_barcode_or_qr") }}
        </div>
        <img
          class="image"
          src="@/assets/images/Kiosk-Barcode.png"
          alt="scanner"
        />
      </div>
      <div class="mb-3">
        <Label> {{ $t("kiosk.type_in_barcode_qr_code") }} </Label>
        <InputField
          class="w-100"
          v-model="state.form.barcode"
          :v-no-auto-fill-input="true"
          :autocomplete="false"
          input-type="password"
          :is-focused="true"
        />
      </div>
      <!-- <div>
        <BaseButton
          class="w-100 d-flex align-items-center justify-content-center"
          rounded
          @click="goToMainScreen"
        >
          {{ $t("kiosk.cancel") }}
        </BaseButton>
      </div> -->
      <!-- Scanner Modal -->
      <CModal
        backdrop="static"
        size="lg"
        class="overflow-auto"
        :visible="state.scannerModalVisible"
        :close-on-backdrop="false"
      >
        <div
          class="p-4 scanner-modal d-flex align-items-center justify-content-between"
        >
          <div class="scanner-modal-container-text flex-1">
            {{ $t("kiosk.scan_your_digital_id_barcode_qr_code") }}
          </div>
          <div
            class="d-inline-block text-black p-1 lh-normal cursor-pointer"
            @click="closeScanner"
          >
            <i class="ri-close-line" />
          </div>
        </div>
        <div class="pb-4 px-4 h-100 text-center">
          <CSpinner
            v-show="state.isScannerLoading"
            color="primary"
            id="cloader"
          />
          <qrcode-stream
            :formats="['qr_code', 'code_128', 'code_39']"
            @detect="onDetect"
            @camera-on="onScannerLaunched"
          />
        </div>
      </CModal>
    </div>
  </div>
</template>

<script>
import Label from "@/v3components/shared/Form/Label.vue"
import CustomSelect from "@/v3components/shared/Form/CustomSelect.vue"
import InputField from "@/v3components/shared/Form/InputField.vue"
// import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"
import LoadingButton from "@/v3components/shared/Buttons/LoadingButton.vue"
import { useStore } from "vuex"
import { onBeforeMount, computed, reactive, watch } from "vue"
import useVuelidate from "@vuelidate/core"
import { helpers } from "@vuelidate/validators"
import InfoBox from "@/v3components/shared/Alerts/InfoBox.vue"
import { QrcodeStream } from "vue-qrcode-reader"
import { useI18n } from "vue-i18n"

export default {
  name: "KioskUserLogin",
  components: {
    Label,
    CustomSelect,
    InputField,
    // BaseButton,
    LoadingButton,
    InfoBox,
    QrcodeStream
  },
  props: ["activeKiosk"],
  emits: ["userLoggedIn", "tabChanged"],
  setup(props, { emit }) {
    const store = useStore()
    const { t } = useI18n()

    const state = reactive({
      isLoading: false,
      auth_type: "studentNumber",
      codeLoginTimeOut: null,
      form: {
        email: null,
        code: null,
        qrCode: "",
        barcode: "",
        studentNumber: ""
      },
      activeDomain: null,
      reqResponse: {
        type: "",
        message: null,
        errors: {}
      },
      authTypes: {
        studentNumber: {
          isVisible: true,
          icon: "ri-user-line"
        },
        standart: {
          isVisible: false,
          icon: "flaticon-user"
        },
        qrcode: {
          isVisible: false,
          icon: "flaticon-credit-card"
        },
        barcode: {
          isVisible: false,
          icon: "flaticon-qr-code"
        }
      },
      isScannerLoading: true,
      scannerModalVisible: false
    })

    const validationMessages = {
      required: "kiosk.this_field_is_required"
    }

    const validations = {
      form: {
        email: {
          required: helpers.withMessage(validationMessages.required, () => {
            return state.authTypes.standart.isVisible
              ? state.form.email.length > 0
              : true
          })
        },
        code: {
          required: helpers.withMessage(validationMessages.required, () => {
            return state.authTypes.standart.isVisible
              ? state.form.code.length > 0
              : true
          })
        },
        qrCode: {
          required: helpers.withMessage(validationMessages.required, () => {
            return state.authTypes.qrcode.isVisible
              ? state.form.qrCode.length > 0
              : true
          })
        },
        barCode: {
          required: helpers.withMessage(validationMessages.required, () => {
            return state.authTypes.barcode.isVisible
              ? state.form.barcode.length > 0
              : true
          })
        },
        studentNumber: {
          required: helpers.withMessage(validationMessages.required, () => {
            return state.authTypes.studentNumber.isVisible
              ? state.form.studentNumber.length > 0
              : true
          })
        }
      }
    }

    const v$ = useVuelidate(validations.form, state.form)

    const isValid = computed(() => !v$.value.$invalid)

    const errors = computed(() => {
      const errorObj = {}
      v$.value.$errors.forEach((err) => {
        errorObj[err.$property] = err.$message
      })

      return errorObj
    })

    // const options = computed(() => {
    //   const kioskModule = store.state.schools.activeSchoolModules.find(
    //     (module) => module.name === "Kiosk"
    //   )
    //   return kioskModule ? Boolean(kioskModule.pivot.status) : false
    // })

    const schoolDomains = computed(() => {
      return props.activeKiosk && props.activeKiosk.school
        ? props.activeKiosk.school.active_domains
        : []
    })

    watch(
      () => state.form.qrCode,
      (newCode, oldCode) => {
        if (newCode != oldCode && newCode.length > 0) {
          loginWithcode("qrCode")
        }
      }
    )

    watch(
      () => state.form.barcode,
      (newCode, oldCode) => {
        if (newCode != oldCode && newCode.length > 0) {
          loginWithcode("barcode")
        }
      }
    )

    onBeforeMount(() => {
      const schoolDomain = schoolDomains.value ? schoolDomains.value[0] : ""
      state.activeDomain =
        props.activeKiosk &&
        props.activeKiosk.defaultDomain != "INVALID DOMAIN NAME"
          ? props.activeKiosk.defaultDomain
          : schoolDomain

      if (props.activeKiosk.loginType) {
        setLoginType(props.activeKiosk.loginType)
      }
    })

    const login = (loginType) => {
      resetResponseMessages()
      if (isValid.value) {
        state.isLoading = true
        let params = {}
        if (loginType == "standart") {
          const passcode = state.form.code
          params = {
            email: state.activeDomain
              ? state.form.email + "@" + state.activeDomain
              : state.form.email,
            code: passcode,
            school_id: props.activeKiosk.school_id
          }
        } else if (loginType == "studentNumber") {
          params = {
            student_number: state.form.studentNumber,
            school_id: props.activeKiosk.school_id
          }
        } else {
          params = {
            code: state.form[loginType],
            school_id: props.activeKiosk.school_id
          }
        }
        store
          .dispatch("kiosks/userLogin", { ...params, type: loginType })
          .then((response) => {
            const data = response.data.data
            if (data) {
              setSuccessResponse(t("kiosk.successfully_logged"))
              store.commit("kiosks/SET_KIOSK_ACCESS_TOKEN", data.access_token)
              store.commit("kiosks/SET_ACTIVE_PASS", data.active_pass)
              getPass()
              emit("userLoggedIn")
            }
            state.isLoading = false
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              const response = err.response.data
              setErrorResponse(response.message, response.errors)
            }
            state.isLoading = false
          })
      } else {
        v$.value.$touch()
      }
    }

    const getPass = () => {
      store.dispatch("kiosks/getPasses").then((res) => {
        const data = res.data
        if (data && data.pass) {
          store.commit("kiosks/SET_ACTIVE_PASS", data.pass)
        }
      })
    }

    const loginWithcode = (loginType) => {
      clearInterval(state.codeLoginTimeOut)
      state.codeLoginTimeOut = setTimeout(() => {
        login(loginType)
      }, 500)
    }

    const setSuccessResponse = (message) => {
      state.reqResponse = {
        type: "success",
        message: message ? message : t("common.successfully_created"),
        errors: {}
      }
    }

    const setErrorResponse = (message, errors) => {
      state.reqResponse = {
        type: "danger",
        message: message ? message : t("kiosk.something_went_wrong"),
        errors: errors ? errors : {}
      }
    }

    const resetResponseMessages = () => {
      state.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    }

    const resetForm = () => {
      state.form = {
        email: null,
        code: null,
        qrCode: "",
        barcode: "",
        studentNumber: ""
      }
      setTimeout(() => {
        v$.value.$reset()
      }, 100)
    }

    const goToMainScreen = () => {
      emit("tabChanged", "userLogin")
      store.commit("kiosks/SET_CREATE_NEW_PASS_DATA", null)
    }

    const setLoginType = (type) => {
      resetResponseMessages()
      resetForm()
      state.auth_type = type
      for (const key in state.authTypes) {
        if (Object.hasOwnProperty.call(state.authTypes, key)) {
          state.authTypes[key].isVisible = key == type
        }
      }
    }

    const launchScanner = () => {
      state.scannerModalVisible = true
    }

    const closeScanner = () => {
      state.scannerModalVisible = false
      state.isScannerLoading = true
    }

    const onDetect = (detectedCode) => {
      closeScanner()
      state.form.barcode = detectedCode[0].rawValue
    }
    const onScannerLaunched = () => {
      state.isScannerLoading = false
    }

    return {
      state,
      isValid,
      errors,
      schoolDomains,
      login,
      loginWithcode,
      goToMainScreen,
      setLoginType,
      launchScanner,
      closeScanner,
      onDetect,
      onScannerLaunched
    }
  }
}
</script>
